import React from "react";
import Navbar from "../components/navbar";
import { Footer } from "../components/Footer";
import { Box } from "@mui/material";
import CardList from "../components/CardList";
import CardList2 from "../components/CardList2";
import TechInternsSection from "../components/TechIntern";
import Perks from "../components/Perks";
import WhyInternWithUs from "../components/WhyInternWithUs";

export const Intern = () => {
  return (
    <div style={{ width: "100%" }}>
      <Navbar />
      <div
        style={{
          position: "sticky",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <p
            style={{
              fontSize: "5vw",
              fontFamily: "Aclonica",
              padding: "0px 5%",
            }}
          >
            {" "}
            Internships that we offer!
          </p>
        </div>
        <div
          className="tech-intern-back-section"
          //   style={{
          //     width: "100%",
          //     backgroundImage: "url('/tech-back.gif')",
          //     backgroundSize: "cover",
          //     backgroundRepeat: "no-repeat",
          //     backgroundPosition: "center",
          //     borderRadius: "100px 100px 0px 0px",
          //     padding: "0px 3%",
          //   }}
        >
          <div style={{ padding: "12px 0" }}>
            <TechInternsSection />

            {/* <div className='row' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', padding: '20px 0px' }}>
                         <div className='intern-card' style={{ width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                         <img src='image 10.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Back-End Developer</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>
                            </div>
                            <div className='intern-card' style={{ width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                                <img src='image 11.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '24px',  fontWeight: '500',fontFamily: 'Aclonica',margin:'0'}}>AI/ML</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card' style={{  width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                                <img src='image 12.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Data Analyst</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                        </div> */}
            <CardList2 />
          </div>
        </div>

        <div
          className="intern-bg"
          style={{
            width: "100%",
            borderRadius: "100px 100px 0px 0px",
            padding: "0px 1px",
          }}
        >
          <Box
            sx={{
              padding: {
                md: "50px",
                sm: "0px",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CardList />

            {/* <div className='row' style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', padding: '20px 0px' }}>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                                <img src='image 2.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '23px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Teaching Assistant Intern</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{ marginBottom:"5%",width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 13.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Business Analyst</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 14.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Business Developer</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 15.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>R&D Intern</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>

                                <img src='image 16.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Content Researcher</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>
                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 17.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Graphic Designer</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 18.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Youtube Content Maker</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            <div className='intern-card2' style={{marginBottom:"5%", width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>

                                <img src='image 19.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                                <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Video Editing Intern</p>
                                <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>
                            </div>
                            <div className='intern-card2' style={{ marginBottom:"5%",width: '28%', borderRadius: '4px', minWidth: '300px', boxShadow: '0px 2px 5px', height: '100%', padding: '10px', backgroundColor: 'white' }}>
                            <img src='image 20.png' style={{ width: '100%', minHeight: '100px', marginTop: '10px', borderRadius: '3px', objectFit: 'cover' }} />
                            <p style={{fontSize: '24px', fontWeight: '500', fontFamily: 'Aclonica',margin:'0'}}>Marketing Intern</p>
                            <p>Other details</p>
                                <button style={{ width: '100%', border: 'none', borderRadius: '25 px', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'white', fontSize: '20px', fontWeight: '500', background: '#30B0C7' }} onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLScDT6gM0C1Kw5IR8VpMCtUPE6J7zaRpTyqmvMdRvdHHGd909w/viewform', '_blank')}>Apply</button>

                            </div>
                            
                        </div> */}
            <p
              style={{
                fontFamily: "Aclonica",
                fontSize: "40px",
                marginTop: "5%",
              }}
            >
              Perks
            </p>

            <div
              className="row"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-around",
                padding: "20px 0px",
                gap: "20px",
              }}
            >
              <div
                className="inside"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "48%",
                  borderRadius: "30px",
                  background: "#97D7E2",
                  height: "60px",
                  padding: "10px",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid #97D7E2",
                    marginRight: "10px",
                  }}
                >
                  <img src="Stack of Money.png" style={{ width: "70%" }} />
                </div>
                <p
                  className="inside-text"
                  style={{ fontFamily: "Aclonica", margin: 0 }}
                >
                  Basic/ Advanced Stipend as per role.
                </p>
              </div>
              <div
                className="inside"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "48%",
                  borderRadius: "30px",
                  background: "#97D7E2",
                  height: "60px",
                  padding: "10px",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid #97D7E2",
                    marginRight: "10px",
                  }}
                >
                  <img src="CV.png" style={{ width: "70%" }} />
                </div>
                <p
                  className="inside-text"
                  style={{ fontFamily: "Aclonica", margin: 0 }}
                >
                  Chance to get Permanent offer.
                </p>
              </div>
              <div
                className="inside"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "48%",
                  borderRadius: "30px",
                  background: "#97D7E2",
                  height: "60px",
                  padding: "10px",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid #97D7E2",
                    marginRight: "10px",
                  }}
                >
                  <img src="Certificate.png" style={{ width: "70%" }} />
                </div>
                <p
                  className="inside-text"
                  style={{ fontFamily: "Aclonica", margin: 0 }}
                >
                  Certificate of Excellence.
                </p>
              </div>
              <div
                className="inside"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "48%",
                  borderRadius: "30px",
                  background: "#97D7E2",
                  height: "60px",
                  padding: "10px",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid #97D7E2",
                    marginRight: "10px",
                  }}
                >
                  <img src="Handshake.png" style={{ width: "70%" }} />
                </div>
                <p
                  className="inside-text"
                  style={{ fontFamily: "Aclonica", margin: 0 }}
                >
                  Connection development and industry exposure.
                </p>
              </div>
              <div
                className="inside"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "48%",
                  borderRadius: "30px",
                  background: "#97D7E2",
                  height: "60px",
                  padding: "10px",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "2px solid #97D7E2",
                    marginRight: "10px",
                  }}
                >
                  <img src="Learning.png" style={{ width: "70%" }} />
                </div>
                <p
                  className="inside-text"
                  style={{ fontFamily: "Aclonica", margin: 0 }}
                >
                  Hands-on learning experience and soft skills development.
                </p>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "18px",
                  fontWeight: "450",
                }}
              >
                and other exciting perks!
              </p>
            </div>
            <p
              style={{
                fontFamily: "Aclonica",
                fontSize: "40px",
                marginTop: "40px",
                marginTop: "5%",
                padding: "0 20px",
              }}
            >
              Why intern with us?
            </p>

            {/* <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="row"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-around",
                  alignItems: "center",
                  padding: "20px 0px",
                  gap: "20px",
                }}
              >
                <div
                  className="internship-box"
                  style={{
                    width: "30%",
                    borderRadius: "4px",
                    height: "300px",
                    minWidth: "280px",
                    borderRadius: "30px",
                    background: "#97D7E2",
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      margin: "0px",
                      borderRadius: "30px",
                      height: "60px",
                      background: "white",
                      border: "2px solid #97D7E2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "500",
                        fontWeight: "550",
                        margin: "0px",
                      }}
                    >
                      Internship Made Simple
                    </p>
                  </div>
                  <p
                    style={{
                      padding: "10%",
                      fontSize: "18px",
                      fontWeight: "450",
                      fontFamily: "roboto",
                    }}
                  >
                    Discover virtual internships in Web Development, App
                    Development, Full Stack, Machine Learning, and Data Science,
                    all designed for focused learning.
                  </p>
                </div>
                <div
                  className="internship-box"
                  style={{
                    width: "30%",
                    borderRadius: "4px",
                    height: "300px",
                    minWidth: "280px",
                    borderRadius: "30px",
                    background: "#97D7E2",
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      margin: "0px",
                      borderRadius: "30px",
                      height: "60px",
                      background: "white",
                      border: "2px solid #97D7E2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "500",
                        fontWeight: "550",
                        margin: "0px",
                      }}
                    >
                      Our Commitment
                    </p>
                  </div>
                  <p
                    style={{
                      padding: "10%",
                      fontSize: "18px",
                      fontWeight: "450",
                      fontFamily: "roboto",
                    }}
                  >
                    We are dedicated to your success, offering a trusted
                    platform for meaningful learning experiences.
                  </p>
                </div>
                <div
                  className="internship-box"
                  style={{
                    width: "30%",
                    borderRadius: "4px",
                    height: "300px",
                    minWidth: "280px",
                    borderRadius: "30px",
                    background: "#97D7E2",
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      margin: "0px",
                      borderRadius: "30px",
                      height: "60px",
                      background: "white",
                      border: "2px solid #97D7E2",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "22px",
                    }}
                  >
                    <p
                      style={{
                        fontWeight: "500",
                        fontWeight: "550",
                        margin: "0px",
                      }}
                    >
                      Guided Skill Development
                    </p>
                  </div>
                  <p
                    style={{
                      padding: "10%",
                      fontSize: "18px",
                      fontWeight: "450",
                      fontFamily: "roboto",
                    }}
                  >
                    Experience growth-focused internships at Yapassio, designed
                    to maximize your skill development.
                  </p>
                </div>
              </div>
            </div> */}
            <WhyInternWithUs />
          </Box>
        </div>
      </div>
      <Footer />
    </div>
  );
};
